import {
  getModule,
  Module,
  MutationAction,
  VuexModule
} from "vuex-module-decorators";
import store from "@/store";
import * as AppDLAPI from "@/api/analysis/app-download";
import { isSuccess } from "@/api/response";
import { AppDownloadGetRequest } from "@/api/analysis/app-download/request";
import { AppDownloadGetResponse } from "@/api/analysis/app-download/response";
import { AnalysisGraphData } from "@/api/analysis/common/response";

const MODULE_NAME = "analysis/app-download/get";

/**
 *  アプリDLAPI（/analysis-app-download）のレスポンスを管理するストアモジュール
 */
@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class Get extends VuexModule {
  // state
  getRequest: AppDownloadGetRequest = {} as AppDownloadGetRequest;
  getResponse: AppDownloadGetResponse = {} as AppDownloadGetResponse;

  // getters
  get isSuccess() {
    return isSuccess(this.getResponse);
  }

  get getMessage() {
    return this.getResponse.message;
  }

  get getData() {
    if (this.getResponse.results) {
      return this.getResponse.results.data;
    } else {
      return {} as AnalysisGraphData;
    }
  }

  get getTotalCount() {
    if (this.getResponse.results) {
      return this.getResponse.results.totalCount || 0;
    } else {
      return 0;
    }
  }

  get getGetRequest() {
    return this.getRequest;
  }
  // MutationActions
  @MutationAction
  async get(getRequest: AppDownloadGetRequest) {
    const getResponse = await AppDLAPI.get(getRequest);
    return {
      getResponse
    };
  }

  @MutationAction
  async clearResponse() {
    return {
      getResponse: {} as AppDownloadGetResponse
    };
  }
}

export default getModule(Get);
